module.exports = __webpack_public_path__ + "img/icon-event-list-orign.6ee93243.svg";